module.exports = __webpack_public_path__ + "static/img/popup_logo.dcd8031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/popup_logo.png
// module id = FA/E
// module chunks = 1